import { useTheme } from 'foundations-theming/utils';
import { AbstractPageTemplate } from '../AbstractPageTemplate/AbstractPageTemplate';
import { jsx as _jsx } from "react/jsx-runtime";
export const DashboardPage = props => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(AbstractPageTemplate, Object.assign({}, props, {
    horizontalDivider: true,
    mainSectionBackgroundColor: theme.color['fill-surface-recessed']
  }));
};
DashboardPage.displayName = 'DashboardPage';